import TCampaignsDetail from './index.vue';

TCampaignsDetail.install = app => {
  app.component(TCampaignsDetail.name, TCampaignsDetail);
};

export default TCampaignsDetail;
